// extracted by mini-css-extract-plugin
export var alertIcon = "_r0-0";